import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from '../../../node_modules/rxjs/operators';

import { ContextMenu, ContextMenuEvent, ContextMenuEventType } from '../models/context-menu.model';

@Injectable({
    providedIn: 'root'
})
export class ContextMenuService {
    private readonly contextMenu: Subject<ContextMenuEvent>;

    constructor(
    ) {
        this.contextMenu = new Subject<ContextMenuEvent>();
    }

    public showMenu(contextMenu: ContextMenu): void {
        this.updateNext(contextMenu, ContextMenuEventType.Open);
    }

    public closeMenu(contextMenu: ContextMenu): void {
        this.updateNext(contextMenu, ContextMenuEventType.Close);
    }

    public subscribeToOpenEvents(callback: (e: ContextMenu) => void): Subscription {
        return this.contextMenu.asObservable().pipe(
            filter(event => event && event.type === ContextMenuEventType.Open),
            map(event => ({ menu: event.menu, position: event.position, focusFirstItem: event.focusFirstItem  }))
        ).subscribe(callback);
    }

    public subscribeToCloseEvents(callback: (e: ContextMenu) => void): Subscription {
        return this.contextMenu.asObservable().pipe(
            filter(event => event && event.type === ContextMenuEventType.Close),
            map(event => ({ menu: event.menu, position: event.position }))
        ).subscribe(callback);
    }

    private updateNext(contextMenu: ContextMenu, type: ContextMenuEventType) {
        if (!contextMenu || !contextMenu.menu || !contextMenu.position) {
            return;
        }
        this.contextMenu.next({
            type,
            menu: contextMenu.menu,
            position: contextMenu.position,
            focusFirstItem: contextMenu.focusFirstItem
        });
    }
}
